// extracted by mini-css-extract-plugin
module.exports = {"radio":"appearance-buttons_radio__F3CJz","active":"appearance-buttons_active__aP41h"};